import React, { Component } from 'react';
import DataTable from '../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';

class SalesListGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }
    componentWillReceiveProps(props) {
        if (props.dataList && props.dataList !== this.props.dataList) {
            let data = props.dataList.map(item => {
                if (item.isTotal) {
                    Object.keys(item).map(key => {
                        if (key !== 'isTotal' && key !== 'grossAmount') {
                            item[key] = '';
                        }
                        return key;
                    });
                    item.stateCode = 'Total';
                }
                return item;
            });
            this.setState({
                data: props.dataList.length > 1 ? data : []
            });
        }
    }
    render() {
        let { singleSelection } = this.props;
        let { data } = this.state;

        return (
            <DataTable
                id="salesListGrid"
                columns={[
                    {
                        title: 'State',
                        data: 'stateCode'
                    },
                    {
                        title: 'Trust<br/>Name',
                        data: 'trustName'
                    },
                    {
                        title: 'Portfolio<br/>Name',
                        data: 'portfolioName'
                    },
                    {
                        title: 'Class<br/>Name',
                        data: 'className'
                    },
                    {
                        title: 'Fund<br/>Cusip',
                        data: 'fundCusip'
                    },
                    {
                        title: 'Trade<br/>Date',
                        data: 'tradeDate'
                    },
                    {
                        title: 'Price<br/>Per Share',
                        data: 'pricePerShare'
                    },
                    {
                        title: 'Share<br/>Amount',
                        data: 'shareAmount'
                    },
                    {
                        title: 'Gross<br/>Amount',
                        data: 'grossAmount'
                    }
                ]}
                pageable
                data={data}
                singleSelection={singleSelection}
                columnFormat={[
                    {
                        targets: [5],
                        render: function(data, type, full) {
                            if (data) {
                                let date = new Date(data);
                                return date.toLocaleDateString('en-US');
                            }
                            else return '';
                        }
                    },
                    {
                        targets: [7],
                        className: 'text-right',
                        render: function(data, type, full) {
                            if (data) {
                                return (
                                    data
                                        .toFixed(4)
                                        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                                );
                            }
                            else return '';
                        }
                    },
                    {
                        targets: [6, 8],
                        className: 'text-right',
                        render: function(data, type, full) {
                            if (data) {
                                return (
                                    '$' +
                                    data
                                        .toFixed(2)
                                        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                                );
                            }
                            else return '';
                        }
                    }
                ]}
                rowFormat={(row, data, dataIndex) => {
                    if (singleSelection) {
                        $(row).css('cursor', 'pointer');
                    }
                    if (data['isTotal']) {
                        $(row).css({'background-color':'#4f6075', 'color':'#fff'});
                    }
                }}
            />
        );
    }
}

SalesListGrid.propTypes = {
    dataList: PropTypes.array.isRequired,
    singleSelection: PropTypes.bool
};

SalesListGrid.defaultProps = {
    singleSelection: false
};

export default SalesListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/SalesListGrid.js